<script>
import { VCheckbox } from 'vuetify/lib'

export default {
  name: 'AgrialCheckbox',
  extends: VCheckbox
}
</script>
